import { Font } from "@react-pdf/renderer";

type FontSourceInternals = {
  data: unknown;
  loadResultPromise: Promise<void> | null;
};

/**
 * react-pdf caches each font file's load promise for the life of the tab — a rejected one
 * included — so one failed font fetch fails every later render, and a "Retry" can never work
 * (SN-19408). Clearing the promise on sources that never loaded makes the next render fetch
 * them again; fonts that did load are left alone.
 *
 * This reaches into @react-pdf/font's internals (`sources`, `data`, `loadResultPromise`). The
 * test runs against the real font store, so an upgrade that changes them fails there instead
 * of turning this into a silent no-op.
 */
export function forgetFailedFontLoads(): void {
  try {
    Object.values(Font.getRegisteredFonts()).forEach((font) => {
      const { sources } = font as unknown as {
        sources?: FontSourceInternals[];
      };
      sources?.forEach((source) => {
        if (source.data === null && source.loadResultPromise !== null) {
          source.loadResultPromise = null;
        }
      });
    });
  } catch (error) {
    // Best effort: the caller is already handling a failed render and must not get a new one.
    console.error("Could not reset failed font loads:", error);
  }
}
